var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

/* globals getComputedStyle */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

var TextfieldWrapper = function TextfieldWrapper(_ref) {
  var children = _ref.children,
      defaultValue = _ref.defaultValue,
      error = _ref.error,
      float = _ref.float,
      icon = _ref.icon,
      label = _ref.label,
      value = _ref.value,
      length = _ref.length,
      htmlFor = _ref.htmlFor,
      suffix = _ref.suffix,
      onSuffixSize = _ref.onSuffixSize,
      dense = _ref.dense;

  var isValueEmpty = value === undefined || value === '';
  var isDefaultValueEmpty = defaultValue === undefined || defaultValue === '';
  var empty = isValueEmpty && isDefaultValueEmpty;
  var valueLength = 0;
  if (!isDefaultValueEmpty) {
    valueLength = defaultValue.length;
  }
  if (!isValueEmpty) {
    valueLength = value.length;
  }
  var showCounter = valueLength > length;
  return React.createElement(
    'label',
    { className: classnames('mdc-Textfield', { 'mdc-Textfield--nolabel': !label }), htmlFor: htmlFor },
    React.createElement(
      'div',
      { className: 'mdc-Textfield-icon-wrapper' },
      icon ? React.createElement(
        'div',
        { className: 'mdc-Textfield-icon' },
        icon
      ) : null,
      React.createElement(
        'div',
        { className: 'mdc-Textfield-wrapper' },
        suffix ? React.createElement(
          'div',
          {
            className: classnames('mdc-Textfield-suffix', {
              'mdc-Textfield-suffix--dense': dense
            }),
            ref: function ref(node) {
              return node && onSuffixSize(node.getClientRects()[0]);
            }
          },
          suffix
        ) : null,
        children,
        React.createElement(
          'span',
          {
            className: classnames('mdc-Textfield-label', {
              'mdc-Textfield-label--dense': dense,
              'mdc-Textfield-label--floatup': !float || !empty,
              'mdc-Textfield-error': showCounter
            })
          },
          label
        ),
        React.createElement(
          'div',
          { className: 'mdc-Textfield-states' },
          React.createElement(
            'span',
            { className: 'mdc-Textfield-error' },
            error
          ),
          length ? React.createElement(
            'span',
            { className: classnames('mdc-Textfield-char-counter', {
                'mdc-Textfield-error': showCounter }) },
            valueLength,
            ' / ',
            length
          ) : null
        )
      )
    )
  );
};

var Textfield = function Textfield(_ref2) {
  var float = _ref2.float,
      error = _ref2.error,
      length = _ref2.length,
      htmlFor = _ref2.htmlFor,
      inputRef = _ref2.inputRef,
      suffix = _ref2.suffix,
      dense = _ref2.dense,
      rest = _objectWithoutProperties(_ref2, ['float', 'error', 'length', 'htmlFor', 'inputRef', 'suffix', 'dense']);

  var inputNode = void 0;
  var suffixRect = void 0;
  var patchInputPadding = function patchInputPadding(_suffixRect) {
    suffixRect = _suffixRect;
  };
  var ref = function ref(node) {
    inputNode = node;
    if (inputRef) {
      inputRef(node);
    }
    if (suffixRect && inputNode) {
      inputNode.style.paddingRight = suffixRect.width + 12 + 'px';
      inputNode.style.boxSizing = 'border-box';
    }
  };
  return React.createElement(
    TextfieldWrapper,
    {
      defaultValue: rest.defaultValue,
      error: error,
      float: float,
      icon: rest.icon,
      label: rest.label,
      value: rest.value,
      length: length,
      htmlFor: htmlFor,
      suffix: suffix,
      onSuffixSize: patchInputPadding,
      dense: dense
    },
    React.createElement('input', _extends({
      className: classnames('mdc-Textfield-input', {
        'mdc-Textfield-input--dense': dense,
        'mdc-Textfield-input--error': error
      }),
      ref: ref
    }, rest))
  );
};

export { Textfield };
Textfield.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  float: PropTypes.bool,
  icon: PropTypes.element,
  label: PropTypes.string,
  length: PropTypes.number
};

Textfield.defaultProps = {
  autoFocus: false,
  disabled: false,
  float: true,
  readOnly: false,
  type: 'text'
};

export var Textarea = function (_React$Component) {
  _inherits(Textarea, _React$Component);

  function Textarea() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, Textarea);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = Textarea.__proto__ || Object.getPrototypeOf(Textarea)).call.apply(_ref3, [this].concat(args))), _this), _this.resize = function (_ref4) {
      var target = _ref4.target;

      var borderBottomHeight = 1;
      var prevHeight = target.style.height;
      // temporarily reset to auto to force re-calc of target.scrollHeight for shrinken input ("deleting text")
      target.style.height = 'auto';
      var newHeight = target.scrollHeight + borderBottomHeight;
      if (_this.props.maxRows) {
        var _getComputedStyle = _this.props.getComputedStyle || getComputedStyle;
        // relies on the line-height css style to be given in px
        var maxHeight = (_this.props.maxRows + 1) * _getComputedStyle(target)['line-height'].split('px')[0];
        if (newHeight < maxHeight) {
          target.style.height = newHeight + 'px';
        } else {
          target.style.height = prevHeight;
        }
      } else {
        target.style.height = newHeight + 'px';
      }
    }, _this.handleInput = function (event) {
      _this.props.onInput && _this.props.onInput(event);
      _this.resize(event);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Textarea, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          defaultValue = _props.defaultValue,
          error = _props.error,
          float = _props.float,
          icon = _props.icon,
          label = _props.label,
          length = _props.length,
          resizable = _props.resizable,
          value = _props.value,
          htmlFor = _props.htmlFor,
          getComputedStyle = _props.getComputedStyle,
          maxRows = _props.maxRows,
          rest = _objectWithoutProperties(_props, ['defaultValue', 'error', 'float', 'icon', 'label', 'length', 'resizable', 'value', 'htmlFor', 'getComputedStyle', 'maxRows']);

      return React.createElement(
        TextfieldWrapper,
        {
          defaultValue: defaultValue,
          error: error,
          float: float,
          icon: icon,
          label: label,
          value: value,
          length: length,
          htmlFor: htmlFor
        },
        React.createElement('textarea', _extends({
          className: classnames('mdc-Textfield-input', {
            'mdc-Textfield-input--error': error
          }),
          defaultValue: defaultValue,
          onInput: this.handleInput,
          style: { resize: resizable ? 'vertical' : 'none', boxSizing: 'border-box', overflowY: 'hidden' },
          value: value
        }, rest))
      );
    }
  }]);

  return Textarea;
}(React.Component);

Textarea.propTypes = {
  autoFocus: PropTypes.bool,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  disabled: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  float: PropTypes.bool,
  icon: PropTypes.element,
  label: PropTypes.string,
  length: PropTypes.number,
  maxRows: PropTypes.number,
  name: PropTypes.string,
  onChange: PropTypes.func,
  readOnly: PropTypes.bool,
  resizable: PropTypes.bool,
  rows: PropTypes.number,
  spellCheck: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

Textarea.defaultProps = {
  autoFocus: false,
  disabled: false,
  float: true,
  readOnly: false,
  resizable: false,
  rows: 2
};


//////////////////
// WEBPACK FOOTER
// ../es/js/textfield/index.js
// module id = 314
// module chunks = 0